import * as React from "react";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import StyledGrid, { FilterChip } from "../../../shared/components/StyledGrid";
import { Link, useNavigate } from "react-router-dom";
import { useGetPaymentsMutation } from "../../../services/InsuranceService";
import useFetchWithMsal from "../../../utils/useFetchWithMsal";
import { LoadingPanel } from "../../../shared/components/LoadingPanel";
import { getPostPaymentPermission } from "../../../shared/utils/permissions";
import { useSelector } from "react-redux";
import { TableFilter } from "../../../components/tableFilter/TableFilter";
import { Typography, Button, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import ExportToExcelButton from "../../../shared/components/ExportToExcelButton";
import { AddPaymentPopup } from "./addPaymentPopup/AddPaymentPopup";
import { MultiFieldContainer } from "../invoicesTab/InvoicesTab.styled";
import { Edit, Refresh, BarChart, CheckCircle, Remove, History } from "@mui/icons-material";
import PaymentHistoryModal from "./PaymentHistoryModal";
import moment from "moment";
import { getCurrence } from "../../../constants/TablesColumns";

export const PaymentsTab = ({ onRedirect, isMemberTab, memberNaicCode, disableFilterReset }) => {
  const roleId = useSelector((state) => state.user.roleId); // Get roleId from Redux store

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  });

  const [rowData, setRowData] = useState(null);

  const paymentsColumns = [
    {
      field: "paymentType",
      headerName: "Payment Type",
      width: 150,
    },
    {
      field: "dateReceived",
      headerName: "Received",
      width: 150,
      valueGetter: (value) =>
        value ? moment.utc(value).local().format("MM/DD/YYYY") : "N/A"
    },
    {
      field: "comments",
      headerName: "Comments",
      width: 300,
      minWidth: 300,
      flex: 0.5,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',             // flex container to allow vertical centering
              alignItems: 'center',        // center vertically within the row
              alignSelf: 'stretch',
              px: 0.75,
              py: 0.5,
              whiteSpace: 'normal',
              overflowWrap: 'break-word',
              wordBreak: 'break-word',
              overflow: 'hidden',          // allow text to wrap without clamping; extra text beyond row height will be clipped
              lineHeight: 1.3,
              textAlign: 'left',
            }}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 110,
      renderCell: (params) => {
        const raw = params?.value;
        const rowIsOpen = params?.row?.isOpen;
        const lower = typeof raw === "string" ? raw.toLowerCase() : raw;
        const isClosed = lower === "closed" || lower === false || rowIsOpen === false;
        // Map: Closed => Licensed styling (green + check icon), Open => Inactive styling (grey + remove icon)
        const pillCfg = isClosed ? {
          bg: '#dff6dd',
          color: 'success.dark',
          icon: <CheckCircle sx={{ fontSize: 14 }} />,
          label: 'Closed'
        } : {
          bg: '#e5e7eb',
          color: 'text.secondary',
          icon: <Remove sx={{ fontSize: 14 }} />,
          label: 'Open'
        };
        return (
          <Box component="span" sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            px: 1,
            py: 0.25,
            borderRadius: '15px',
            fontSize: 12,
            fontWeight: 600,
            bgcolor: pillCfg.bg,
            color: pillCfg.color,
            textTransform: 'capitalize',
            lineHeight: 1,
            minWidth: 70,
            justifyContent: 'center'
          }}>
            {pillCfg.icon}
            {pillCfg.label}
          </Box>
        );
      }
    },
    {
      field: "paymentAmount",
      headerName: "Payment Amount",
      width: 75,
      valueFormatter: getCurrence,
    },
    {
      field: "appliedAmount",
      headerName: "Applied Amount",
      width: 75,
      valueFormatter: getCurrence,
    },
    /*  {
       field: "invoiceNumber",
       headerName: "Invoice Number",
       width: 100,
       renderCell: (params) => (
         <Typography
           className="link"
           onClick={() =>
             onRedirect("invoices", params?.row?.invoiceNumber)
           }
         >
           {params.value}
         </Typography>
       ),
     }, */
    /*     {
          field: "groupCode",
          headerName: "Group Code",
          width: 75,
        }, */
    /*   {
        field: "naicCode",
        headerName: "NAIC Code",
        width: 75,
        renderCell: (params) => {
          //console.log('params?.value', params?.row?.naicCode);
          const isSpecial = params?.value === ' 998000';
          return (
            <Box sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              px: 0.5,
              bgcolor: isSpecial ? '#f3f4f6' : 'transparent',
            }}>
              {params.value}
            </Box>
          );
        }
      }, */
    /*     {
          field: "memberName",
          headerName: "Member Name",
          width: 300,
          minWidth: 200,
          flex: 1,
          renderCell: (params) => {
            const isSpecial = params?.row?.naicCode === ' 998000';
            return (
              <Box sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'flex-start',
                px: 0.5,
                bgcolor: isSpecial ? '#f3f4f6' : 'transparent',
              }}>
                <Box sx={{ whiteSpace: 'normal', overflowWrap: 'break-word', wordBreak: 'break-word' }}>{params.value}</Box>
              </Box>
            );
          }
        }, */
    /*  {
       field: "groupName",
       headerName: "Group Name",
       width: 300,
       minWidth: 200,
       flex: 1,
     },
     {
       field: "assessmentTitle",
       headerName: "Assessment Title",
       width: 300,
       minWidth: 200,
       flex: 1,
       renderCell: (params) => {
         const isSpecial = params?.row?.naicCode === ' 998000';
         return (
           <Box sx={{
             width: '100%',
             height: '100%',
             display: 'flex',
             alignItems: 'flex-start',
             px: 0.5,
             bgcolor: isSpecial ? '#f3f4f6' : 'transparent',
           }}>
             <Box sx={{ whiteSpace: 'normal', overflowWrap: 'break-word', wordBreak: 'break-word' }}>{params.value}</Box>
           </Box>
         );
       }
     }, */
    // {
    //   field: "assessmentDate",
    //   headerName: "Assessment Date",
    //   width: 100,
    //   valueGetter: (value) =>
    //     value ? moment(value).utc().format("MM/DD/YYYY") : "N/A",
    // },
    {
      field: "edit",
      headerName: "",
      width: 100,
      flex: 0.2,
      editable: true,
      renderCell: (params) => (
        <MultiFieldContainer>
          <Edit
            style={{
              cursor:
                getPostPaymentPermission(roleId) && // Use permission function
                /*  !params?.row?.parentPaymentId &&
                 params?.row?.paymentAmount !== params?.row?.appliedAmount &&  */
                params?.row?.paymentAmount !== null &&
                "pointer",
              color:
                getPostPaymentPermission(roleId) && // Use permission function
                  /*    !params?.row?.parentPaymentId &&
                     params?.row?.paymentAmount !== params?.row?.appliedAmount &&*/
                  params?.row?.paymentAmount !== null
                  ? "#003366"
                  : "gray",
            }}
            onClick={() =>
              getPostPaymentPermission(roleId) && // Use permission function
              /*               !params?.row?.parentPaymentId &&
                            params?.row?.paymentAmount !== params?.row?.appliedAmount &&
                            params?.row?.paymentAmount !== null && */
              onEditClick(params)
            }
          />
          <History
            sx={{ ml: 1, cursor: 'pointer', color: '#003366' }}
            onClick={() => onOpenHistory(params?.row?.id || params?.row?.paymentId || params?.row?.paymentKey)}
          />
        </MultiFieldContainer>
      ),
    },
  ];

  const onEditClick = (e) => {
    setRowData(e.row);
    setShowAddPaymentPopup(!showAddPaymentPopup);
  };

  const [totalCount, setTotalCount] = useState(0);

  const [showAddPaymentPopup, setShowAddPaymentPopup] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyPaymentKey, setHistoryPaymentKey] = useState(null);
  // Reports menu state
  const [reportsAnchorEl, setReportsAnchorEl] = useState(null);
  const onOpenReportsMenu = (e) => setReportsAnchorEl(e.currentTarget);
  const onCloseReportsMenu = () => setReportsAnchorEl(null);
  const openReport = (url, label) => {
    if (!url) {
      /* eslint-disable no-console */
      console.warn(`[PaymentsTab] No URL configured for report: ${label}`);
      /* eslint-enable no-console */
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    onCloseReportsMenu();
  };

  // Default sorting: Date Received descending
  const [sortingModel, setSortingModel] = useState({ field: 'dateReceived', sort: 'desc' });
  const { skip } = useFetchWithMsal();
  const [getPayments, { data, isLoading }] = useGetPaymentsMutation("", {
    skip,
  });

  const { naicCode, memberName, paymentOpenStatus, paymentReceivedDate, invoiceNumber, groupName } = useSelector((state) => state.filter);

  useEffect(() => {
    const body = {
      invoiceNumber: invoiceNumber,
      groupName: groupName,
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      orderBy: sortingModel?.field || "",
      orderByDirection: sortingModel?.sort || "",
      naicCode: memberNaicCode || "",
      memberName: memberName,
      isOpen: getStatus(paymentOpenStatus),
      dateReceived: paymentReceivedDate,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    getPayments(body);
  }, [
    paginationModel.page,
    paginationModel.pageSize,
    sortingModel?.field,
    sortingModel?.sort,
    memberNaicCode,
    isMemberTab
  ]);

  useEffect(() => {
    if (!isLoading) {
      if (data?.totalCount !== totalCount) {
        setTotalCount(data?.totalCount);
      }
    }
  }, [isLoading]);

  const getStatus = (value) => {
    if (value === 'All') {
      return null;
    } else if (value === 'Open') {
      return true;
    } else if (value === 'Closed') {
      return false;
    } else {
      return null;
    }
  };

  const fetchData = (value) => {
    const body = {
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      orderBy: sortingModel?.field || "",
      orderByDirection: sortingModel?.sort || "",
      naicCode: isMemberTab ? memberNaicCode : value ? value.naicCode : naicCode,
      memberName: value ? value.memberName : memberName,
      isOpen: value ? getStatus(value.paymentOpenStatus) : getStatus(paymentOpenStatus),
      dateReceived: value ? (value.paymentReceivedDate || null) : paymentReceivedDate,
      invoiceNumber: value ? value.invoiceNumber : invoiceNumber,
      groupName: value ? value.groupName : groupName,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    getPayments(body);
  };

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const onApplyFilters = (value) => {
    if (paginationModel.page) {
      setPaginationModel((prev) => {
        return { ...prev, page: 0 };
      });
    } else {
      fetchData(value);
    }
  };

  const onPopupClose = () => {
    setShowAddPaymentPopup(false);
    setRowData(null);
    // Auto-refresh the grid after closing the Add Payment dialog
    fetchData();
  };

  const onOpenHistory = (paymentKey) => {
    if (!paymentKey) return;
    setHistoryPaymentKey(paymentKey);
    setHistoryOpen(true);
  };
  const onCloseHistory = () => {
    setHistoryOpen(false);
    setHistoryPaymentKey(null);
  };

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        margin: isMemberTab ? "0 auto 0 auto" : "50px auto 0 auto",
      }}
    >
      {isLoading && <LoadingPanel />}
      {isMemberTab && (
        <Box display={"flex"} ml={"auto"} sx={{ justifyContent: "flex-end", gap: 1 }} mb={3}>
          {getPostPaymentPermission(roleId) && (
            <Button variant="outlined" onClick={() => { setRowData(null); setShowAddPaymentPopup(true); }}>
              Add Payment
            </Button>
          )}
          <Button variant="outlined" onClick={() => fetchData()} startIcon={<Refresh />}>Refresh</Button>
          <ExportToExcelButton
            rows={data?.payments || []}
            columns={paymentsColumns}
            filename="payments.xlsx"
            label="Export"
          />
          <Button
            variant="outlined"
            startIcon={<BarChart fontSize="small" />}
            onClick={onOpenReportsMenu}
          >
            Reports
          </Button>
          <Menu
            anchorEl={reportsAnchorEl}
            open={Boolean(reportsAnchorEl)}
            onClose={onCloseReportsMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            <MenuItem onClick={() => openReport('', 'Payments By Week')}>
              <ListItemIcon><BarChart fontSize="small" /></ListItemIcon>
              <ListItemText primary="Payments By Week" />
            </MenuItem>
            <MenuItem onClick={() => openReport('', 'Payments By Period')}>
              <ListItemIcon><BarChart fontSize="small" /></ListItemIcon>
              <ListItemText primary="Payments By Period" />
            </MenuItem>
          </Menu>
          <TableFilter onApplyFilters={onApplyFilters} isMemberTab={isMemberTab} type={"payments"} disableFilterReset={disableFilterReset} />
        </Box>
      )}
      {!isMemberTab && (
        <Box display={"flex"} sx={{ justifyContent: "space-between" }} mb={3}>
          <Typography variant="h1" color="primary.main" sx={{ marginLeft: "16px" }}>
            Payments
          </Typography>

          <Box display={"flex"} ml={"auto"} sx={{ gap: 2 }}>
            {getPostPaymentPermission(roleId) && (
              <Button variant="outlined" onClick={() => { setRowData(null); setShowAddPaymentPopup(true); }}>
                Add Payment
              </Button>
            )}
            <Button variant="outlined" onClick={() => fetchData()} startIcon={<Refresh />}>Refresh</Button>
            <ExportToExcelButton
              rows={data?.payments || []}
              columns={paymentsColumns}
              filename="payments.xlsx"
              label="Export"
            />
            <Button
              variant="outlined"
              startIcon={<BarChart fontSize="small" />}
              onClick={onOpenReportsMenu}
            >
              Reports
            </Button>
            <Menu
              anchorEl={reportsAnchorEl}
              open={Boolean(reportsAnchorEl)}
              onClose={onCloseReportsMenu}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
              <MenuItem onClick={() => openReport('https://app.powerbi.com/groups/17de80d1-c228-4727-8b60-4f42eb7649dd/reports/cd95a26b-d99d-424f-b7f7-0f896df185db/566165526d79c12ebe0d?experience=power-bi', 'Payments By Week')}>
                <ListItemIcon><BarChart fontSize="small" /></ListItemIcon>
                <ListItemText primary="Payments By Week" />
              </MenuItem>
              <MenuItem onClick={() => openReport('https://app.powerbi.com/groups/17de80d1-c228-4727-8b60-4f42eb7649dd/reports/cd95a26b-d99d-424f-b7f7-0f896df185db/af1f27e5786c2bcc4773?experience=power-bi', 'Payments By Period')}>
                <ListItemIcon><BarChart fontSize="small" /></ListItemIcon>
                <ListItemText primary="Payments By Period" />
              </MenuItem>
            </Menu>
            <TableFilter onApplyFilters={onApplyFilters} type={"payments"} />
          </Box>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
          alignItems: "center",
          marginRight: "15px",
          marginBottom: "15px",
        }}
      >
        {naicCode && <FilterChip>NAIC Code: {naicCode}</FilterChip>}
        {groupName && <FilterChip>Group Name: {groupName}</FilterChip>}
        {memberName && <FilterChip>Insolvent Company: {memberName}</FilterChip>}
        {paymentReceivedDate && <FilterChip>Received date: {paymentReceivedDate}</FilterChip>}
        {paymentOpenStatus && <FilterChip>Status: {paymentOpenStatus}</FilterChip>}
        {invoiceNumber && <FilterChip>Invoice Number: {invoiceNumber}</FilterChip>}
      </Box>

      <StyledGrid
        data={data?.payments}
        width="100%"
        columns={paymentsColumns}
        rowCount={totalCount}
        withFilter
        onSortingModelChange={(model) => setSortingModel(model[0])}
        sortModel={sortingModel ? [sortingModel] : []}
        paginationModel={paginationModel}
        setPaginationModel={handlePaginationModelChange}
        rowHeight={108} // ~3x default (default ~52). Provides space for multi-line wrapped comments.
      // withMenu
      />
      <AddPaymentPopup
        open={showAddPaymentPopup}
        onClose={onPopupClose}
        data={rowData}
      />
      <PaymentHistoryModal open={historyOpen} onClose={onCloseHistory} paymentKey={historyPaymentKey} />
    </Box>
  );
};
